import { Navigate } from "react-router-dom";

/** Legacy route — user types live under Settings. */
const BusinessTypeManagement = () => <Navigate to="/sa/settings?tab=user-types" replace />;

export default BusinessTypeManagement;
